import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';

const PermissionAlert = () => {
  return /* @__PURE__ */ React.createElement(Alert, { severity: "warning", "data-testid": "no-permission-alert" }, /* @__PURE__ */ React.createElement(AlertTitle, null, "Permission required"), "To view quay image registry, contact your administrator to give you the quay.view.read permission.");
};

export { PermissionAlert as default };
//# sourceMappingURL=PermissionAlert.esm.js.map
